import { render, staticRenderFns } from "./AppImg.vue?vue&type=template&id=bc9a4b3a&"
import script from "./AppImg.vue?vue&type=script&lang=js&"
export * from "./AppImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports